import styled from 'styled-components';

export const GlideListWrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex: 10;
  color: var(--foreground-form);
`;
